// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"atMAAbmX","sun":"OHR9jZOg","sunRise":"ISdy0007","moon":"mkr7O8bR","dateContainer":"jJP2HIBs","timeLabel":"XaFyhvC1"};